import Vue from 'vue';

export const progressState = Vue.observable({ pending: 0 });

export function pushProgress(): void {
  progressState.pending += 1;
}

export function popProgress(): void {
  progressState.pending = Math.max(0, progressState.pending - 1);
}
